import { toNumber } from 'lodash';
import difference from 'lodash/difference';
import toString from 'lodash/toString';

import { capitalizeFirstLetter } from './function';

export const formatNumberWithComma = (x) => {
    let parts = toString(x).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
};

export const formatGameDisplay = (game, data, t) => {
    switch (game) {
        case 'colok_jitu':
            // eslint-disable-next-line no-case-declarations
            const [num, position] = data;
            return `${num} ${t('position')} ${capitalizeFirstLetter(position)}`;
        case 'colok_naga':
        case 'colok_bebas_2d':
            // eslint-disable-next-line no-case-declarations
            const clone = [...data];
            // eslint-disable-next-line no-case-declarations
            const lastItem = [...clone].slice(-1)[0];
            clone.splice(-1, 1);
            return `${clone.join(', ')} ${t('and')} ${lastItem}`;
        case 'shio':
            return t(data);
        case 'kombinasi':
        case '5050':
            return data.map(g => t(g)).join(' ');
        case 'kembang_kempis':
        case 'silang_homo':
            return data.map(g => t(g)).reverse().join(' ');
        case '5050_2d':
        case 'tepi_tengah':
        case 'dasar':
            return t(data[0]);
        default:
            return data;
    }
};

export const formatPeriod = (period) => {
    if (period === 0) {
        return '000';
    }
    if (!!period) {
        if (period.length === 3) {
            return period;
        }
        let arr = [];
        for (let i = 0; i < 3 - `${period}`.length; i++) {
            arr.push(0);
        }
        return `${arr.join('')}${period}`;
    }
};


export const formatDecimal = (num, places = 4) => {
    if (toNumber(num) < 1) {
        const numberFixed = new Intl.NumberFormat('default', {
            style: 'percent',
            minimumFractionDigits: 0,
            maximumFractionDigits: places,
        }).format(num);
        return numberFixed;
    }
    return '0%';
};

export const convertDay = (day, typeDay = 'draw_day', listDays, t) => {
    if (day === '') {
        return 'N/A';
    }
    const listDaysDisplay = day.substring(1, day.length - 1).split(',').map(Number);
    if (typeDay === 'draw_day') {
        if (listDaysDisplay.length === 7) {
            return t('Everyday');
        }
        const reFormat = listDaysDisplay.map(num => {
            switch (num) {
                case 1:
                    return t('Monday');
                case 2: return t('Tuesday');
                case 3: return t('Wednesday');
                case 4: return t('Thursday');
                case 5: return t('Friday');
                case 6: return t('Saturday');
                case 0: return t('Sunday');
                default:
                    return t('Sunday');
            }
        });
        return reFormat.join(', ');
    }
    if (typeDay === 'holiday') {
        const holidaysDisplay = difference(listDays, listDaysDisplay);
        if (holidaysDisplay.length === 0) {
            return 'N/A';
        }
        const reFormat = holidaysDisplay.map(num => {
            switch (num) {
                case 1:
                    return t('Monday');
                case 2: return t('Tuesday');
                case 3: return t('Wednesday');
                case 4: return t('Thursday');
                case 5: return t('Friday');
                case 6: return t('Saturday');
                default:
                    return t('Sunday');
            }
        });
        return reFormat.join(', ');
    }
};

export const mapTranslateAction = (action_type) => {
    switch (action_type) {
        case 'cancel':
            return 'cancelled';
        case 'approve':
            return 'approved';
        case 'pending':
            return 'pending';
        case 'success':
            return 'Success';
        case 'rejected':
            return 'rejected';
        case 'failed':
            return 'Unsuccess';
        case 'cancel_by_member':
            return 'cancel_by_member';
        case 'processing':
            return 'processing';
        default:
            return `${action_type}ed`;
    }
};

export const renderColorBadge = (status) => {
    const colors = {
        approved: 'success',
        success: 'success',
        rejected: 'danger',
        cancel_by_member: 'danger',
        processing: 'primary',
        failed: 'warning',
    };

    return colors[status] ?? 'info';
};

export const formatAmountDesc = (credit, debit) => {
    return +credit ? formatNumberWithComma(credit) : formatNumberWithComma(debit);
};
